var map = {
	"./active": 593,
	"./active.js": 593,
	"./legacy": 594,
	"./legacy.js": 594
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1245;


//////////////////
// WEBPACK FOOTER
// ./src/packages/@ncigdc/theme/versions ^\.\/.*$
// module id = 1245
// module chunks = 31